import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useGenderPopup } from "../context/GenderPopupContext";

const HARBIZ_LINKS = {
  POWER: "https://app.harbiz.io/checkout-form/retomastercom?product=wmZBP2jzcoH4GekYz&lang=es",
  BOOTY: "https://app.harbiz.io/checkout-form/retomastercom?product=dhuLyuK5JL54YsqND&lang=es",
};

export default function HarbizPlans() {
  const { t } = useI18n();
  const { setOpen } = useGenderPopup();
  const tp = t.trainingPlans;

  return (
    <section id="plans" className="relative py-24 sm:py-32 border-t border-white/5" data-testid="harbiz-plans-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="text-xs tracking-[0.4em] text-[#FF6B00] uppercase">{tp.eyebrow}</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 uppercase">
            {tp.title}
          </h2>
          <p className="mt-4 text-zinc-400 text-sm tracking-wide max-w-xl mx-auto">{tp.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {tp.plans.map((plan, i) => (
            <motion.div
              key={plan.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative glass-card p-8 lg:p-10 flex flex-col lift-card"
              data-testid={`harbiz-plan-${plan.name.toLowerCase()}`}
            >
              <div className="absolute -top-3 left-6 bg-[#FF6B00] text-black text-[10px] font-bold tracking-[0.25em] px-3 py-1 uppercase">
                {tp.trialBadge}
              </div>
              <div className="font-display text-4xl tracking-wide uppercase mt-2">{plan.name}</div>
              <div className="text-sm text-zinc-400 mt-1">{plan.tagline}</div>
              <p className="mt-3 text-zinc-500 text-xs leading-relaxed">{plan.description}</p>

              <div className="mt-6 flex items-baseline gap-2">
                <span className="text-zinc-500 text-xl font-light">$</span>
                <span className="font-display text-5xl sm:text-6xl">{plan.price}</span>
                <span className="text-zinc-500 text-sm tracking-wide">{tp.perMonth}</span>
              </div>

              <div className="mf-divider my-6" />

              <ul className="space-y-3 mb-8 grow">
                {plan.features.map((f, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm text-zinc-300">
                    <Check size={16} className="mt-1 shrink-0 text-[#FF6B00]" strokeWidth={3} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href={HARBIZ_LINKS[plan.name]}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-center py-4 text-xs tracking-[0.3em] font-bold uppercase bg-[#FF6B00] text-black btn-glow transition-all"
                data-testid={`harbiz-cta-${plan.name.toLowerCase()}`}
              >
                {tp.cta}
              </a>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-zinc-500 text-xs tracking-wide mb-4">
            {t.locale === "es"
              ? "¿No estás seguro qué plan es para ti?"
              : "Not sure which plan is for you?"}
          </p>
          <button
            onClick={() => setOpen(true)}
            className="inline-flex items-center gap-2 border border-white/20 text-white hover:border-[#FF6B00] hover:text-[#FF6B00] text-xs tracking-[0.25em] font-bold uppercase py-3 px-8 transition-all"
          >
            {t.exitPopup.badge} →
          </button>
        </div>
      </div>
    </section>
  );
}
